import ConsumptionAnalysisIcon from './component'

export default ConsumptionAnalysisIcon